import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import EmojiTitleQueryArtifact, {
	type EmojiTitleQuery$data,
	type EmojiTitleQuery$variables,
} from './__generated__/EmojiTitleQuery.graphql.ts';

export const preloadEmojiTitle = (
	contentId: EmojiTitleQuery$variables['contentId'],
	draftShareId: EmojiTitleQuery$variables['draftShareId'],
	useCache: boolean,
) => {
	return query<EmojiTitleQuery$data, EmojiTitleQuery$variables>({
		query: EmojiTitleQueryArtifact,
		variables: {
			contentId,
			draftShareId,
			status: ['current', 'draft'],
			skipPublishedFragment: false,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
};
